import { parse, stringify } from 'flatted';
import { createTransform } from 'redux-persist';
import { ConversationFilterEnum } from '~/enums/conversations';
import { AccountInfoState } from '~/types/accountInfo';
import { initialState as initialConversationState } from './reducers/conversation';
import { initialState as initialAccountState } from './reducers/accountInfo';

// Define a minimal persisted shape
type PersistedAccountInfo = Pick<AccountInfoState, 'tourCompleted'>;

export const accountInfoTransform = createTransform<
  AccountInfoState, // inbound state (from Redux)
  PersistedAccountInfo // outbound state (to storage)
>(
  inbound => ({
    tourCompleted: inbound.tourCompleted,
  }),
  outbound => ({
    ...initialAccountState,
    tourCompleted: outbound?.tourCompleted,
  }),
  { whitelist: ['accountInfo'] }
);

export const systemTransform = createTransform(
  // Before persist (inbound)
  (inboundState: any) =>
    stringify({
      ...inboundState,
      showUpdaterMessage: true,
      temporaryCountryCode: null,
    }),

  // Before rehydrate (outbound)
  outboundState => {
    const outbound = parse(outboundState);
    return {
      ...outbound,
      showUpdaterMessage: true,
      temporaryCountryCode: null,
      status: outbound.status === 'Available' ? 'Unavailable' : outbound.status,
    };
  },

  // Only apply to 'system' reducer
  { whitelist: ['system'] }
);

const checkConversationFilters = (outbound: any) => {
  const { type } = outbound.filters;

  if (type !== ConversationFilterEnum.MY_MESSAGES) {
    return { conversations: [] };
  }

  return {};
};

export const conversationTransform = createTransform(
  // Before persist (inbound)
  inboundState => stringify(inboundState),

  // Before rehydrate (outbound)
  outboundState => {
    const outbound = parse(outboundState);
    return {
      ...outbound,
      hiddenBottomNav: false,
      openSelection: false,
      lastReadIndex: 0,
      filters: initialConversationState.filters,
      ...checkConversationFilters(outbound),
    };
  },

  // Only apply to 'conversation' reducer
  { whitelist: ['conversation'] }
);
